export function getFullName(firstName: string, lastName: string) {
    return [firstName, lastName].join(' ');
}
